import React, { useState } from "react";
import { Grid, Header, Icon, Message, Button, Form } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../../app/common/modals/modalSlice";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import {
  addLinkDocToDb,
  updateTransUpdatedInDb,
} from "../../../../app/firestore/firestoreService";

export default function DocWebLinkUpload({ setOpenDocUploadModal }) {
  const dispatch = useDispatch();
  const { transaction } = useSelector((state) => state.transaction);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");

  function normalizeUrl(value) {
    const trimmed = value.trim();
    if (!/^https?:\/\//i.test(trimmed)) {
      return `https://${trimmed}`;
    }
    return trimmed;
  }

  function isValidUrl(value) {
    try {
      const parsed = new URL(normalizeUrl(value));
      return !!parsed.hostname && parsed.hostname.includes(".");
    } catch (e) {
      return false;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!url.trim()) {
      setError("Please enter a URL");
      return;
    }

    if (!isValidUrl(url)) {
      setError("Please enter a valid website URL (e.g. https://example.com)");
      return;
    }

    if (!transaction || !transaction.id || !transaction.userId) {
      setError(
        "Transaction information is missing. Please refresh the page and try again."
      );
      return;
    }

    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const finalUrl = normalizeUrl(url);
      const finalName = name.trim() || finalUrl;

      await addLinkDocToDb(transaction, finalUrl, finalName);
      await updateTransUpdatedInDb(transaction.id);

      setMessage(`Successfully added link: ${finalName}`);
      setUrl("");
      setName("");

      setTimeout(() => {
        if (setOpenDocUploadModal) {
          setOpenDocUploadModal(false);
        }
        dispatch(closeModal({ modalType: "DocAddDocumentsModal" }));
      }, 1500);
    } catch (error) {
      console.error("Error adding link:", error);
      setError(error.message || "Failed to add link");
    } finally {
      setLoading(false);
    }
  };

  const containerStyles = {
    padding: "20px",
    textAlign: "center",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Grid>
      <Grid.Column width={16}>
        <div style={containerStyles}>
          <Header icon color="grey">
            <Icon name="linkify" />
            <br />
            Add Website Link
          </Header>

          <Form
            onSubmit={handleSubmit}
            style={{ width: "100%", maxWidth: "500px" }}
          >
            <Form.Input
              placeholder="Paste URL (e.g. https://example.com)"
              value={url}
              onChange={(e) => {
                setUrl(e.target.value);
                if (error) setError(null);
                if (message) setMessage(null);
              }}
            />
            <Form.Input
              placeholder="Optional name for this link"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <Button
              type="submit"
              primary
              disabled={loading || !url.trim()}
              style={{ marginTop: "10px" }}
            >
              {loading ? "Adding..." : "Add Link"}
            </Button>
          </Form>
        </div>

        {loading && <LoadingComponent />}

        {(error || message) && (
          <Message
            negative={!!error}
            positive={!!message}
            style={{ marginTop: "15px" }}
          >
            <Message.Header>{error ? "Add Failed" : "Link Added"}</Message.Header>
            <p>{error || message}</p>
          </Message>
        )}
      </Grid.Column>
    </Grid>
  );
}
